import PersonaAPI from "./PersonaAPI";

const PersonaApiClient = new PersonaAPI();

export default PersonaApiClient;